import { render, staticRenderFns } from "./ImportUploader.vue?vue&type=template&id=610295d8&scoped=true&"
import script from "./ImportUploader.vue?vue&type=script&lang=js&"
export * from "./ImportUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610295d8",
  null
  
)

export default component.exports